import { render, staticRenderFns } from "./_.vue?vue&type=template&id=545ad4e1&scoped=true&"
import script from "./_.vue?vue&type=script&lang=js&"
export * from "./_.vue?vue&type=script&lang=js&"
import style0 from "./_.vue?vue&type=style&index=0&id=545ad4e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545ad4e1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogFooterCta: require('/opt/build/repo/components/global/BlogFooterCta.vue').default,BlogPostCard: require('/opt/build/repo/components/BlogPostCard.vue').default})
